var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('span',{staticClass:"badge fw-bold px-3 py-2",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm._f("formatPaymentStatus")(_vm.status))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }